import {
  WHEEL_TYPE_ALL,
  WHEEL_TYPE_GET,
  WHEEL_TYPE_POST,
  WHEEL_TYPE_PUT,
  WHEEL_TYPE_DELETE,
  WHEEL_TYPE_LOADING,
  WHEEL_TYPE_ERROR,
} from '../types';

import api from '../../../utils/functions/api';

export const wheelTypeCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: WHEEL_TYPE_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/wheel-type`,
      {
        ...payload,
      },
    );
    dispatch({ type: WHEEL_TYPE_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEEL_TYPE_ERROR });
  }
};

export const wheelTypeAll = (params) => async (dispatch) => {
  try {
    const { name = '', size = '', page = 1 } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/wheel-type?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: WHEEL_TYPE_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEEL_TYPE_ERROR });
  }
};

export const wheelTypeGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/wheel-type/${id}`,
    );
    if (status === 200) {
      dispatch({ type: WHEEL_TYPE_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEEL_TYPE_ERROR });
  }
};

export const wheelTypePut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: WHEEL_TYPE_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/wheel-type/${id}`,
      payload,
    );
    dispatch({ type: WHEEL_TYPE_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEEL_TYPE_ERROR });
  }
};
export const wheelTypeDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: WHEEL_TYPE_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/wheel-type/${id}`,
    );
    dispatch({ type: WHEEL_TYPE_DELETE, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: WHEEL_TYPE_ERROR });
  }
};
